import { Button, Container } from "react-bootstrap"
import { Envelope, Bell } from "react-bootstrap-icons"

export const Subscription = () => {
    return (
        <Container className="my-5">
            <div className="d-flex justify-content-center">
                <div className="border-0 d-flex p-4 rounded-4 gap-4 align-items-center"
                    style={{ 
                        maxWidth: "800px",
                        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    }}
                    // onMouseEnter={(e) => {
                    //     e.currentTarget.style.transform = "translateY(-4px)"
                    //     e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.12)"
                    // }}
                    // onMouseLeave={(e) => {
                    //     e.currentTarget.style.transform = "translateY(0)"
                    //     e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.08)"
                    // }}
                >
                    <div className="flex-fill" style={{ minWidth: "200px" }}>
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <Bell className="text-primary" size={24} />
                            <div className="fs-4 fw-semibold" style={{ lineHeight: 1.3 }}>
                                Узнавайте новости <br />
                                <span className="text-primary" style={{ 
                                    background: "linear-gradient(90deg, #764ba2, #4d2971)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    backgroundClip: "text"
                                }}>
                                    Ленинград центра
                                </span> первыми!
                            </div>
                        </div>
                        <p className="text-secondary mb-0" style={{ fontSize: "0.95rem" }}>
                            Подпишитесь на новости шоу-пространства, чтобы быть в курсе всех событий первыми.
                        </p>
                    </div>
                    
                    <div className="d-flex justify-content-center align-items-center" style={{ minWidth: "150px" }}>
                        <Button 
                            className="btn-afisha px-4 py-2 rounded-pill fw-semibold d-flex align-items-center gap-2"
                            style={{
                                background: "linear-gradient(90deg, #764ba2, #4d2971)",
                                border: "none",
                                transition: "all 0.3s ease",
                                boxShadow: "0 4px 15px rgba(13, 110, 253, 0.3)",
                                whiteSpace: "nowrap"
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.05)"
                                e.currentTarget.style.boxShadow = "0 6px 25px rgba(13, 110, 253, 0.4)"
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)"
                                e.currentTarget.style.boxShadow = "0 4px 15px rgba(13, 110, 253, 0.3)"
                            }}
                        >
                            <Envelope size={18} />
                            Подписаться
                        </Button>
                    </div>
                </div>
            </div>
        </Container>
    )
}